export const bgdiaMonsters = [
  {
    name: "Abyssal Chicken",
    source: "BGDIA",
    page: 97,
    size: ["T"],
    type: {
      type: "fiend",
      tags: ["demon"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 10,
      formula: "3d4 + 3",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(see bad flier below)",
      },
    },
    str: 6,
    dex: 14,
    con: 13,
    int: 4,
    wis: 9,
    cha: 5,
    senses: ["blindsight 30 ft. (blind beyond this radius)"],
    passive: 9,
    resist: ["cold", "fire", "lightning"],
    immune: ["poison"],
    conditionImmune: ["blinded", "poisoned"],
    languages: ["understands Abyssal but can't speak"],
    cr: "1/4",
    trait: [
      {
        name: "Bad Flier",
        entries: [
          "The abyssal chicken falls at the end of a turn if it's airborne and the only thing holding it aloft is its flying speed.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The abyssal chicken makes two attacks: one with its bite and one with its claws.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one creature. {@h}4 ({@damage 1d4 + 2}) piercing damage.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d6 + 2}) slashing damage.",
        ],
      },
    ],
    familiar: true,
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "CS"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Amrik Vanthampur",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 30,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["{@item leather armor|phb}", "charisma modifier"],
      },
    ],
    hp: {
      average: 66,
      formula: "12d8 + 12",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 18,
    con: 12,
    int: 14,
    wis: 14,
    cha: 15,
    skill: {
      acrobatics: "+6",
      athletics: "+3",
      deception: "+6",
      insight: "+6",
    },
    passive: 12,
    languages: ["Common", "Infernal"],
    cr: "3",
    trait: [
      {
        name: "Suave Defense",
        entries: [
          "While Amrik is wearing light or no armor and wielding no shield, his AC includes his Charisma modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Amrik makes three dagger attacks."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 6} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage.",
        ],
      },
      {
        name: "Smoke Bomb (1/Day)",
        entries: [
          "Amrik hurls a smoke bomb up to 20 feet away. The bomb explodes on impact, creating a cloud of black smoke that fills a 10-foot-radius sphere. The area within the cloud is heavily obscured. A strong wind disperses the cloud, which otherwise remains until the end of Amrik's next turn.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "I"],
    damageTags: ["P"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Archduke Zariel of Avernus",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 243,
    _copy: {
      name: "Zariel",
      source: "MTF",
      _mod: {
        action: [
          {
            mode: "replaceArr",
            replace: "Multiattack",
            items: {
              name: "Multiattack",
              entries: [
                "Zariel attacks twice with her flail and once with Matalotok. She can substitute Horrid Touch for Matalotok.",
              ],
            },
          },
          {
            mode: "replaceArr",
            replace: "Longsword",
            items: {
              name: "Flail",
              entries: [
                "{@atk mw} {@hit 16} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d8 + 8}) piercing damage plus 36 ({@damage 8d8}) fire damage.",
              ],
            },
          },
          {
            mode: "replaceArr",
            replace: "Javelin",
            items: {
              name: "Matalotok (Warhammer)",
              entries: [
                "{@atk mw} {@hit 16} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d8 + 8}) bludgeoning, or 19 ({@damage 2d10 + 8}) bludgeoning damage if used with two hands, plus 36 ({@damage 8d8}) fire damage. In addition, the weapon emits a burst of cold that deals 10 ({@damage 3d6}) cold damage to each creature within 30 feet of it.",
              ],
            },
          },
        ],
      },
    },
    resist: [
      "fire",
      "radiant",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't silvered",
        cond: true,
      },
    ],
    immune: ["cold", "necrotic", "poison"],
    damageTags: ["B", "C", "F", "N", "P"],
    damageTagsLegendary: [],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Arkhan the Cruel",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 111,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["dragonborn"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 23,
        from: [
          "{@item obsidian flint dragon plate|bgdia}",
          "{@item shield|phb}",
        ],
      },
    ],
    hp: {
      average: 221,
      formula: "26d8 + 104",
    },
    speed: {
      walk: 40,
    },
    str: 20,
    dex: 12,
    con: 18,
    int: 10,
    wis: 10,
    cha: 18,
    save: {
      wis: "+5",
      cha: "+9",
    },
    skill: {
      athletics: "+10",
      deception: "+9",
      intimidation: "+9",
    },
    senses: [
      "darkvision 60 ft. (can see invisible creatures out to the same range)",
    ],
    passive: 10,
    resist: [
      "fire",
      "poison",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic"],
    cr: "16",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Arkhan's spellcasting ability is Charisma (spell save {@dc 17}). He can cast the following spells, requiring no material components:",
        ],
        daily: {
          "3e": [
            "{animate dead}",
            "{branding smite} (at 4th level)",
            "{revivify}",
          ],
          "1e": ["{geas}", "{raise dead}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Aura of Hate",
        entries: [
          "While Arkhan isn't {@condition incapacitated}, he and all fiends and undead within 30 feet of him deal 4 extra damage whenever they hit with a melee weapon attack (already factored into Arkhan's attacks). This extra damage is of the same type as the weapon's damage type.",
        ],
      },
      {
        name: "Hand of Vecna",
        entries: [
          "The {@item Hand of Vecna} has 8 charges and regains {@dice 1d4 + 4} expended charges daily at dawn. Arkhan can cast the following spells from the hand by expending the specified number of charges (spell save {@dc 18}): {finger of death} (5 charges), {sleep} (1 charge), {slow} (2 charges), and {teleport} (3 charges).",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Arkhan wields {@item Fane-Eater|bgdia} and wears a suit of {@item Obsidian Flint Dragon Plate|bgdia}. The armor gives Arkhan advantage on ability checks and saving throws made to avoid or end the {@condition grappled} condition on him.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Arkhan makes three weapon attacks."],
      },
      {
        name: "Fane-Eater (Battleaxe)",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 5 ft., one target. {@h}16 ({@damage 1d8 + 12}) slashing damage, or 17 ({@damage 1d10 + 12}) slashing damage when used with two hands, plus 9 ({@damage 2d8}) cold damage. If the target is a creature and Arkhan rolls a 20 on the attack roll, the creature takes an extra 9 ({@damage 2d8}) necrotic damage, and Arkhan regains an amount of hit points equal to the necrotic damage dealt.",
        ],
      },
      {
        name: "Javelin",
        entries: [
          "{@atk mw,rw} {@hit 10} to hit, reach 5 ft. or range 30/120 ft., one target. {@h}8 ({@damage 1d6 + 5}) piercing damage, plus 4 piercing damage and 9 ({@damage 2d8}) cold damage if the javelin was used to make a melee attack.",
        ],
      },
    ],
    attachedItems: ["fane-eater|bgdia", "javelin|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["C", "N", "P", "S"],
    damageTagsSpell: ["R", "Y"],
    spellcastingTags: ["I"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Bel",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 115,
    size: ["L"],
    type: {
      type: "fiend",
      tags: ["devil"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 364,
      formula: "27d10 + 216",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 28,
    dex: 14,
    con: 26,
    int: 25,
    wis: 19,
    cha: 26,
    save: {
      dex: "+10",
      con: "+16",
      wis: "+12",
    },
    skill: {
      arcana: "+15",
      deception: "+16",
      insight: "+12",
      persuasion: "+16",
    },
    senses: ["truesight 120 ft."],
    passive: 14,
    resist: [
      "cold",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't silvered",
        cond: true,
      },
    ],
    immune: ["fire", "poison"],
    conditionImmune: ["poisoned"],
    languages: ["Common", "Infernal", "telepathy 120 ft."],
    cr: "25",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Bel's spellcasting ability is Charisma (spell save {@dc 23}). Bel can innately cast the following spells, requiring no material components:",
        ],
        will: ["{detect magic}", "{fireball}"],
        daily: {
          "3e": [
            "{dispel magic}",
            "{hold monster}",
            "{mirror image}",
            "{mislead}",
            "{raise dead}",
            "{teleport}",
            "{wall of fire}",
          ],
          "1e": ["{imprisonment}", "{meteor swarm}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Fear Aura",
        entries: [
          "Any creature hostile to Bel that starts its turn within 20 feet of him must make a {@dc 23} Wisdom saving throw, unless Bel is {@condition incapacitated}. Unless the save succeeds, the creature is {@condition frightened} until the start of its next turn. If a creature's saving throw is successful, the creature is immune to Bel's Fear Aura for the next 24 hours.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If Bel fails a saving throw, he can choose to succeed instead.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "Bel has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["Bel's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Bel makes three attacks: two with his greatsword and one with his tail.",
        ],
      },
      {
        name: "Greatsword",
        entries: [
          "{@atk mw} {@hit 16} to hit, reach 10 ft., one target. {@h}23 ({@damage 4d6 + 9}) slashing damage plus 21 ({@damage 6d6}) fire damage. If the target is a flammable object that is not being held or worn, it catches fire.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 16} to hit, reach 10 ft., one target. {@h}25 ({@damage 3d10 + 9}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 23} Constitution saving throw or be {@condition stunned} until the end of its next turn.",
        ],
      },
    ],
    legendary: [
      {
        name: "Fireball",
        entries: ["Bel casts {fireball}."],
      },
      {
        name: "Tactical Edge (Costs 2 Actions)",
        entries: [
          "Roll a {@dice d6} for Bel. The number rolled on the die is subtracted from the next attack roll made against Bel or an ally of his choice within the next minute.",
        ],
      },
      {
        name: "Summon Ice Devil (Costs 3 Actions)",
        entries: [
          "Bel magically summons an ice devil with an ice spear (as described in the ice devil's entry in the Monster Manual). The ice devil appears in an unoccupied space within 60 feet of Bel, acts as Bel's ally, and can summon other devils if it has such power. The ice devil remains until Bel dies or until he dismisses it as an action.",
        ],
      },
    ],
    attachedItems: ["greatsword|phb"],
    traitTags: ["Legendary Resistances", "Magic Resistance", "Magic Weapons"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "I"],
    damageTags: ["B", "F", "S"],
    damageTagsSpell: ["B", "F"],
    spellcastingTags: ["I"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["frightened", "stunned"],
    conditionInflictSpell: [
      "blinded",
      "deafened",
      "invisible",
      "paralyzed",
      "restrained",
    ],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Bitter Breath",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 90,
    _copy: {
      name: "Horned Devil",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the devil",
          with: "Bitter Breath",
          flags: "i",
        },
      },
    },
    speed: {
      walk: 20,
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Black Gauntlet of Bane",
    source: "BGDIA",
    page: 235,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 16,
        from: ["{@item chain mail|phb}"],
      },
    ],
    hp: {
      average: 51,
      formula: "6d8 + 24",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 11,
    con: 18,
    int: 12,
    wis: 15,
    cha: 18,
    save: {
      wis: "+5",
    },
    skill: {
      intimidation: "+7",
      perception: "+5",
    },
    passive: 15,
    conditionImmune: ["frightened"],
    languages: ["Common"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The black gauntlet is a 5th-level spellcaster. Its spellcasting ability is Charisma (spell save {@dc 15}, {@hit 7} to hit with spell attacks). It has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: ["{guidance}", "{sacred flame}", "{thaumaturgy}"],
          },
          1: {
            slots: 4,
            spells: [
              "{bane}",
              "{bless}",
              "{cure wounds}",
              '{guiding bolt} (see "Actions" below)',
            ],
          },
          2: {
            slots: 3,
            spells: ["{blindness/deafness}", "{hold person}", "{silence}"],
          },
          3: {
            slots: 2,
            spells: ["{sending}", "{spirit guardians}"],
          },
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Aura of Terror",
        entries: [
          "When a hostile creature within 5 feet of the black gauntlet makes an attack roll or a saving throw, it has disadvantage on the roll. Creatures that are immune to the {@condition frightened} condition are immune to this trait.",
        ],
      },
      {
        name: "Tactical Discipline",
        entries: [
          "The black gauntlet has advantage on all ability checks and saving throws made during combat.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The black gauntlet makes two attacks with its mace."],
      },
      {
        name: "Mace",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d6 + 4}) bludgeoning damage plus 13 ({@damage 3d8}) necrotic damage.",
        ],
      },
      {
        name: "Guiding Bolt (1st-Level Spell; Requires a Spell Slot)",
        entries: [
          "{@atk rs} {@hit 7} to hit, range 120 ft., one creature. {@h}14 ({@damage 4d6}) radiant damage, and the next attack roll made against the target before the end of the black gauntlet's next turn has advantage. If the black gauntlet casts this spell using a spell slot of 2nd level or higher, the damage increases by {@dice 1d6} for each slot level above 1st.",
        ],
      },
    ],
    attachedItems: ["mace|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["B", "N", "R"],
    damageTagsSpell: ["N", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW"],
    conditionInflictSpell: ["blinded", "deafened", "paralyzed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Bone Whelk",
    source: "BGDIA",
    page: 119,
    size: ["L"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 27,
      formula: "5d10",
    },
    speed: {
      walk: 15,
      climb: 15,
    },
    str: 10,
    dex: 5,
    con: 11,
    int: 6,
    wis: 9,
    cha: 3,
    senses: ["darkvision 60 ft."],
    passive: 9,
    cr: "1/4",
    trait: [
      {
        name: "Adhesive",
        entries: [
          "The bone whelk can cause Medium or smaller objects to adhere to it. A Medium or smaller creature that touches the bone whelk is {@condition grappled} by it (escape {@dc 10}).",
        ],
      },
      {
        name: "Death Scream",
        entries: [
          "When the bone whelk dies, it emits a blood-curdling shriek than can be heard out to a range of 120 feet. This shriek causes nonmagical, organic material within 10 feet of the bone whelk to rot. Each creature within 10 feet of the bone whelk when it dies takes 9 ({@damage 2d8}) necrotic damage.",
        ],
      },
      {
        name: "Spider Climb",
        entries: [
          "The bone whelk can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one creature. {@h}4 ({@damage 1d8}) piercing damage.",
        ],
      },
    ],
    traitTags: ["Spider Climb"],
    senseTags: ["D"],
    damageTags: ["N", "P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Burney the Barber",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 129,
    _copy: {
      name: "Ancient Copper Dragon",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the dragon",
          with: "Burney",
          flags: "i",
        },
        trait: {
          mode: "appendArr",
          items: [
            {
              name: "Healer",
              entries: [
                "Burney has the benefits of the {@feat healer} feat as well as proficiency with both the {@item healer's kit|phb} and the {@item herbalism kit|phb}.",
              ],
            },
            {
              name: "Bahamut's Blessings",
              entries: [
                "Burney has received several blessings in her service to Bahamut:",
                {
                  type: "list",
                  items: [
                    "Unless Burney decided otherwise, once any creature less powerful than a deity has taken three steps from her, they can no longer remember her or having interacted with her specifically.",
                    "Burney is under the effect of a permanent {mind blank} spell, and cannot be detected by magical or mundane means unless she wishes it. In exchange for this blessing, Burney can take no direct action against the denizens of the Nine Hells, though she can certainly enlist the help of those who can.",
                    "Burney always knows the location of the Wandering Emporium and can transport herself there as though by a {word of recall} spell. This explains why Burney simply seems to appear amid the fully deployed marketplace each morning it is active to provide service and tell stories.",
                    "Once each day, when Burney so desires, she can instantly transport herself to the court of Bahamut via a powerful blessing akin to the {plane shift} spell.",
                  ],
                },
              ],
            },
          ],
        },
      },
    },
    damageTagsLegendary: [],
    hasToken: true,
  },
  {
    name: "Chukka",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 83,
    _copy: {
      name: "Kenku",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the kenku",
          with: "Chukka",
          flags: "i",
        },
      },
    },
    action: [
      {
        name: "Silvered Pike",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d10}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["silvered pike|phb"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Clonk",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 83,
    _copy: {
      name: "Kenku",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the kenku",
          with: "Clonk",
          flags: "i",
        },
      },
    },
    action: [
      {
        name: "Hellfire Warhammer",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d8}) bludgeoning damage, or 5 ({@damage 1d10 + 1}) bludgeoning damage if used with two hands to make a melee attack.",
        ],
      },
    ],
    attachedItems: ["hellfire warhammer|bgdia"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Crokek'toeck",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 231,
    size: ["G"],
    type: {
      type: "fiend",
      tags: ["demon"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 297,
      formula: "17d20 + 119",
    },
    speed: {
      walk: 60,
      swim: 60,
    },
    str: 28,
    dex: 10,
    con: 24,
    int: 6,
    wis: 10,
    cha: 13,
    save: {
      con: "+12",
      wis: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 10,
    resist: [
      "cold",
      "fire",
      "lightning",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    immune: ["poison"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["understands Abyssal but can't speak"],
    cr: "14",
    trait: [
      {
        name: "Amphibious",
        entries: ["Crokek'toeck can breathe air and water."],
      },
      {
        name: "Magic Resistance",
        entries: [
          "Crokek'toeck has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["Crokek'toeck's weapon attacks are magical."],
      },
      {
        name: "Secure Memory",
        entries: [
          "Crokek'toeck is immune to the waters of the River Styx as well as any effect that would steal or modify its memories or detect or read its thoughts.",
        ],
      },
      {
        name: "Standing Leap",
        entries: [
          "Crokek'toeck's long jump is up to 60 feet and its high jump is up to 30 feet, with or without a running start.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 14} to hit, reach 15 ft., one target. {@h}44 ({@damage 10d6 + 9}) piercing damage.",
        ],
      },
      {
        name: "Disgorge Allies {@recharge}",
        entries: [
          "Crokek'toeck opens its mouth and disgorges {@dice 1d4} {@creature barlgura||barlguras}, {@dice 3d6} {@creature gnoll||gnolls} led by 1 {@creature gnoll fang of Yeenoghu}, {@dice 6d6} {@creature dretch||dretches}, or {@dice 1d3} {@creature vrock||vrocks}. Each creature it disgorges appears in an unoccupied space within 30 feet of Crokek'toeck's mouth, or the next closest unoccupied space.",
        ],
      },
    ],
    traitTags: ["Amphibious", "Magic Resistance", "Magic Weapons"],
    senseTags: ["SD"],
    languageTags: ["AB", "CS"],
    damageTags: ["P"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Death's Head of Bhaal",
    source: "BGDIA",
    page: 233,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "E"],
    ac: [15],
    hp: {
      average: 76,
      formula: "8d8 + 40",
    },
    speed: {
      walk: 50,
    },
    str: 20,
    dex: 20,
    con: 20,
    int: 14,
    wis: 13,
    cha: 16,
    skill: {
      intimidation: "+6",
      perception: "+4",
      persuasion: "+6",
      stealth: "+11",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    languages: ["Common"],
    cr: "5",
    trait: [
      {
        name: "Aura of Murder",
        entries: [
          "As long as the death's head is not {@condition incapacitated}, hostile creatures within 5 feet of it gain vulnerability to piercing damage unless they have resistance or immunity to such damage.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The death's head has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The death's head uses Stunning Gaze and makes two dagger attacks.",
        ],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d4 + 5}) piercing damage.",
        ],
      },
      {
        name: "Stunning Gaze",
        entries: [
          "The death's head targets one creature it can see within 30 feet of it. The target must succeed on a {@dc 14} Wisdom saving throw or be {@condition stunned} until the end of its next turn.",
        ],
      },
    ],
    reaction: [
      {
        name: "Unstoppable (3/Day)",
        entries: [
          "The death's head reduces the damage it takes from an attack to 0.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    traitTags: ["Magic Resistance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["stunned"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Dryad Spirit",
    source: "BGDIA",
    page: 108,
    _copy: {
      name: "Banshee",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "banshee",
          with: "dryad",
        },
      },
    },
    hasToken: true,
  },
  {
    name: "Duke Thalamra Vanthampur",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 38,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [10],
    hp: {
      average: 78,
      formula: "12d8 + 24",
    },
    speed: {
      walk: 30,
    },
    str: 17,
    dex: 10,
    con: 15,
    int: 13,
    wis: 16,
    cha: 18,
    skill: {
      deception: "+6",
      insight: "+5",
      intimidation: "+6",
      religion: "+3",
    },
    senses: ["darkvision 120 ft. (see devil's sight below)"],
    passive: 13,
    languages: ["Common", "Infernal"],
    cr: "4",
    trait: [
      {
        name: "Dark Devotion",
        entries: [
          "Thalamra has advantage on saving throws against being {@condition charmed} or {@condition frightened}.",
        ],
      },
      {
        name: "Devil's Sight",
        entries: [
          "Thalamra can see normally in darkness, both magical and nonmagical, out to a distance of 120 feet.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Thalamra uses eldritch blast twice or makes two unarmed strikes.",
        ],
      },
      {
        name: "Eldritch Blast (Cantrip)",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 120 ft., one creature. {@h}9 ({@damage 1d10 + 4}) force damage.",
        ],
      },
      {
        name: "Unarmed Strike",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}4 bludgeoning damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Hellish Rebuke (1st-Level Spell; 2/Day)",
        entries: [
          "When Thalamra is damaged by a creature within 60 feet of her that she can see, the creature that damaged her is engulfed in hellish flames and must make a {@dc 14} Dexterity saving throw, taking 16 ({@damage 3d10}) fire damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Devil's Sight"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "I"],
    damageTags: ["B", "F", "O"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Elliach",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 130,
    _copy: {
      name: "Mage",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the mage",
          with: "Elliach",
          flags: "i",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    action: [
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 5} to hit, reach 10 ft. or range 20/60 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    miscTags: ["MW", "RCH", "RW", "THW"],
    hasToken: true,
  },
  {
    name: "Feonor",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 130,
    _copy: {
      name: "Archmage",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the archmage",
          with: "Feonor",
          flags: "i",
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Fiendish Flesh Golem",
    source: "BGDIA",
    page: 236,
    size: ["L"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 210,
      formula: "20d10 + 100",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 20,
    dex: 9,
    con: 20,
    int: 7,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    resist: ["cold", "fire"],
    immune: [
      "lightning",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't adamantine or silvered",
        cond: true,
      },
    ],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "8",
    trait: [
      {
        name: "Berserk",
        entries: [
          "Whenever the golem starts its turn with 100 hit points or fewer, roll a {@dice d6}. On a 6, the golem goes berserk. On each of its turns while berserk, the golem attacks the nearest creature it can see. If no creature is near enough to move to and attack, the golem attacks an object, with preference for an object smaller than itself. Once the golem goes berserk, it continues to do so until it is destroyed or regains all its hit points. If the golem's creator is within 60 feet of the berserk golem, the creator can try to calm it by speaking firmly and persuasively. The golem must be able to hear its creator, who must take an action to make a {@dc 15} Charisma (Persuasion) check. If the check succeeds, the golem ceases being berserk. If it takes damage while still at 100 hit points or fewer, the golem might go berserk again.",
        ],
      },
      {
        name: "Immutable Form",
        entries: [
          "The golem is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Lightning Absorption",
        entries: [
          "Whenever the golem is subjected to lightning damage, it takes no damage and instead regains a number of hit points equal to the lightning damage dealt.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The golem has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["The golem's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes two slam attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}16 ({@damage 2d10 + 5}) bludgeoning damage.",
        ],
      },
    ],
    traitTags: [
      "Damage Absorption",
      "Immutable Form",
      "Magic Resistance",
      "Magic Weapons",
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Fist of Bane",
    source: "BGDIA",
    page: 232,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 18,
        from: ["{@item chain mail|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 11,
    con: 13,
    int: 10,
    wis: 12,
    cha: 11,
    passive: 11,
    conditionImmune: ["frightened"],
    languages: ["Common"],
    cr: "1/2",
    trait: [
      {
        name: "Tactical Discipline",
        entries: [
          "The fist of Bane has advantage on all ability checks and saving throws made during combat.",
        ],
      },
    ],
    action: [
      {
        name: "Mace",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d6 + 3}) bludgeoning damage.",
        ],
      },
      {
        name: "Longbow",
        entries: [
          "{@atk rw} {@hit 2} to hit, range 150/600 ft., one target. {@h}4 ({@damage 1d8}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["longbow|phb", "mace|phb"],
    languageTags: ["C"],
    damageTags: ["B", "P"],
    miscTags: ["MW", "RNG", "RW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Flying Dagger",
    source: "BGDIA",
    page: 30,
    _copy: {
      name: "Flying Sword",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "sword",
          with: "dagger",
        },
        action: {
          mode: "replaceArr",
          replace: "Longsword",
          items: {
            name: "Dagger",
            entries: [
              "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}3 ({@damage 1d4 + 1}) piercing damage.",
            ],
          },
        },
      },
    },
    size: ["T"],
    hp: {
      average: 7,
      formula: "3d4",
    },
    cr: "1/8",
    damageTags: ["P"],
    hasToken: true,
  },
  {
    name: "Gideon Lightward",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 65,
    size: ["M"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [11],
    hp: {
      average: 136,
      formula: "16d8 + 64",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 13,
    con: 18,
    int: 10,
    wis: 18,
    cha: 13,
    save: {
      dex: "+4",
      con: "+7",
      wis: "+7",
    },
    skill: {
      insight: "+7",
      religion: "+6",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    resist: [
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    immune: ["necrotic", "poison"],
    vulnerable: ["radiant"],
    conditionImmune: ["exhaustion", "paralyzed", "poisoned"],
    languages: ["Common"],
    cr: "6",
    trait: [
      {
        name: "Regeneration",
        entries: [
          "Gideon regains 10 hit points at the start of each of his turns. If he takes radiant damage, this trait doesn't function at the start of his next turn. Gideon is destroyed only if he starts his turn with 0 hit points and doesn't regenerate.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Gideon attacks twice with his fists."],
      },
      {
        name: "Fist",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d6 + 4}) bludgeoning damage.",
        ],
      },
      {
        name: "Withering Gaze",
        entries: [
          "Gideon targets one creature he can see within 60 feet of him. The target must make a {@dc 15} Constitution saving throw, taking 22 ({@damage 4d10}) necrotic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Regeneration"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["B", "N"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Harkina Hunt",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 53,
    _copy: {
      name: "Commoner",
      source: "MM",
      _mod: {
        action: {
          mode: "appendArr",
          items: {
            name: "Longbow",
            entries: [
              "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d8}) piercing damage.",
            ],
          },
        },
      },
    },
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    damageTags: ["B", "P"],
    miscTags: ["MW", "RNG"],
    hasToken: true,
  },
  {
    name: "Hellwasp",
    source: "BGDIA",
    page: 236,
    size: ["L"],
    type: "fiend",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d10 + 8",
    },
    speed: {
      walk: 10,
      fly: {
        number: 60,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 18,
    dex: 15,
    con: 12,
    int: 10,
    wis: 10,
    cha: 7,
    save: {
      dex: "+5",
      wis: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["fire"],
    vulnerable: ["cold"],
    languages: ["Infernal", "telepathy 300 ft. (with other hellwasps only)"],
    cr: "5",
    trait: [
      {
        name: "Magic Weapons",
        entries: ["The hellwasp's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The hellwasp makes two attacks: one with its sting and one with its sword talons.",
        ],
      },
      {
        name: "Sting",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one creature. {@h}8 ({@damage 1d8 + 4}) piercing damage plus 7 ({@damage 2d6}) fire damage, and the target must succeed on a {@dc 12} Constitution saving throw or be {@condition poisoned} for 1 minute. While {@condition poisoned} in this way, the target is also {@condition paralyzed}. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
      {
        name: "Sword Talons",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d6 + 4}) piercing damage.",
        ],
      },
    ],
    traitTags: ["Magic Weapons"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["I", "TP"],
    damageTags: ["F", "P"],
    miscTags: ["MW"],
    conditionInflict: ["paralyzed", "poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Hellwasp Grub",
    source: "BGDIA",
    page: 95,
    _copy: {
      name: "Giant Centipede",
      source: "MM",
    },
    hasToken: true,
  },
  {
    name: "Hollyphant",
    source: "BGDIA",
    page: 237,
    size: ["S"],
    type: "celestial",
    alignment: ["L", "G"],
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 36,
      formula: "8d6 + 8",
    },
    speed: {
      walk: 20,
      fly: 120,
    },
    str: 10,
    dex: 11,
    con: 12,
    int: 16,
    wis: 19,
    cha: 16,
    save: {
      dex: "+3",
      con: "+4",
      cha: "+6",
    },
    passive: 14,
    resist: [
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["Celestial", "telepathy 120 ft."],
    cr: "5",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "The hollyphant's innate spellcasting ability is Wisdom (spell save {@dc 15}). It can innately cast the following spells, requiring no material components:",
        ],
        will: ["{light}"],
        daily: {
          "2e": ["{bless}", "{cure wounds}", "{protection from evil and good}"],
          "1e": [
            "{banishment}",
            "{heal}",
            "{raise dead}",
            "{shapechange} (into a golden-furred {@creature mammoth} with feathered wings and a flying speed of 120 ft.)",
            "{teleport} (with no chance of error)",
          ],
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Aura of Invulnerability",
        entries: [
          "An {@condition invisible} aura forms a 10-foot-radius sphere around the hollyphant for as long as it lives. Any spell of 5th level or lower cast from outside the barrier can't affect creatures or objects within it, even if the spell is cast using a higher level spell slot. Such a spell can target creatures and objects within the barrier, but the spell has no effect on them. Similarly, the area within the barrier is excluded from the areas affected by such spells. The hollyphant can use an action to suppress this trait until its {@status concentration} ends (as if {@status concentration||concentrating} on a spell).",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["The hollyphant's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Tusks",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}3 ({@damage 1d6}) piercing damage.",
        ],
      },
      {
        name: "Trumpet (3/Day)",
        entries: [
          "The hollyphant blows air through its trunk, creating a trumpet sound that can be heard out to a range of 600 feet. The trumpet also creates a 30-foot cone of energy that has one of the following effects, chosen by the hollyphant:",
        ],
      },
      {
        name: "Trumpet of Blasting",
        entries: [
          "Each creature in the cone must make a {@dc 14} Constitution saving throw. On a failed save, a creature takes 17 ({@damage 5d6}) thunder damage and is {@condition deafened} for 1 minute. On a successful save, a creature takes half as much damage and isn't {@condition deafened}. Nonmagical objects in the cone that aren't being held or worn take 35 ({@damage 10d6}) thunder damage.",
        ],
      },
      {
        name: "Trumpet of Sparkles",
        entries: [
          "Creatures in the cone must make a {@dc 14} Constitution saving throw, taking 22 ({@damage 4d8 + 4}) radiant damage on a failed save, or half as much damage on a successful one. Evil creatures have disadvantage on the saving throw. Good creatures in the cone take no damage.",
        ],
      },
    ],
    traitTags: ["Magic Weapons"],
    languageTags: ["CE", "TP"],
    damageTags: ["P", "R", "T"],
    spellcastingTags: ["I"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["deafened"],
    conditionInflictSpell: ["incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Iron Consul",
    source: "BGDIA",
    page: 232,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 16,
        from: ["{@item chain mail|phb}"],
      },
    ],
    hp: {
      average: 45,
      formula: "6d8 + 18",
    },
    speed: {
      walk: 30,
    },
    str: 17,
    dex: 11,
    con: 16,
    int: 12,
    wis: 15,
    cha: 16,
    save: {
      wis: "+4",
    },
    skill: {
      intimidation: "+5",
      perception: "+4",
    },
    passive: 14,
    conditionImmune: ["frightened"],
    languages: ["Common"],
    cr: "2",
    trait: [
      {
        name: "Tactical Discipline",
        entries: [
          "The iron consul has advantage on all ability checks and saving throws made during combat.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The iron consul makes one attack with its spear and can use its Voice of Command ability.",
        ],
      },
      {
        name: "Spear",
        entries: [
          "{@atk mw,rw} {@hit 5} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d6 + 3}) piercing damage, or 7 ({@damage 1d8 + 3}) piercing damage when used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Voice of Command",
        entries: [
          "The iron consul selects up to two allies within 90 feet of it that can hear its commands. Each ally can immediately use its reaction to make one melee attack.",
        ],
      },
    ],
    attachedItems: ["spear|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Kostchtchie",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 105,
    size: ["L"],
    type: {
      type: "fiend",
      tags: ["demon"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 243,
      formula: "18d10 + 144",
    },
    speed: {
      walk: 40,
    },
    str: 30,
    dex: 12,
    con: 27,
    int: 18,
    wis: 22,
    cha: 19,
    save: {
      dex: "+9",
      con: "+16",
      wis: "+14",
    },
    skill: {
      intimidation: "+12",
      perception: "+14",
      survival: "+14",
    },
    senses: ["truesight 120 ft."],
    passive: 24,
    resist: ["fire", "lightning"],
    immune: [
      "cold",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Abyssal", "Giant", "telepathy 120 ft."],
    cr: "25",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Kostchtchie's innate spellcasting ability is Charisma (spell save {@dc 20}). He can innately cast the following spells, requiring no material components:",
        ],
        will: ["{command}", "{darkness}"],
        daily: {
          "1e": [
            "{dispel evil and good}",
            "{gate}",
            "{harm}",
            "{telekinesis}",
            "{teleport}",
            "{wind walk}",
          ],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If Kostchtchie fails a saving throw, he can choose to succeed instead.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "Kostchtchie has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Kostchtchie makes two melee attacks, only one of which can be a bite attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 5 ft., one creature. {@h}13 ({@damage 1d6 + 10}) piercing damage.",
        ],
      },
      {
        name: "Matalotok (Warhammer)",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage, or 21 ({@damage 2d10 + 10}) bludgeoning damage when used with two hands, and the weapon emits a burst of cold that deals 10 ({@damage 3d6}) cold damage to each creature within 30 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["Kostchtchie makes one melee weapon attack."],
      },
      {
        name: "Charge",
        entries: ["Kostchtchie moves up to his speed."],
      },
      {
        name: "Curse (Costs 2 Actions)",
        entries: [
          "Kostchtchie curses one creature he can see within 60 feet of him. The cursed creature gains vulnerability to all damage dealt by Kostchtchie until the end of Kostchtchie's next turn.",
        ],
      },
    ],
    attachedItems: ["matalotok|bgdia"],
    traitTags: ["Legendary Resistances", "Magic Resistance"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "GI", "TP"],
    damageTags: ["B", "C", "P"],
    damageTagsSpell: ["N"],
    spellcastingTags: ["I"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Krull",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 110,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["tortle"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 117,
      formula: "18d8 + 36",
    },
    speed: {
      walk: 30,
    },
    str: 20,
    dex: 14,
    con: 15,
    int: 12,
    wis: 20,
    cha: 12,
    save: {
      wis: "+8",
      cha: "+4",
    },
    skill: {
      arcana: "+4",
      medicine: "+8",
      nature: "+4",
      survival: "+8",
    },
    passive: 15,
    languages: ["Aquan", "Common", "Draconic"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Krull is a 14th-level spellcaster. His spellcasting ability is Wisdom (spell save {@dc 16}, {@hit 8} to hit with spell attacks). He has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{chill touch}",
              "{mending}",
              "{resistance}",
              "{sacred flame}",
              "{spare the dying}",
              "{thaumaturgy}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{cure wounds}",
              "{detect evil and good}",
              "{false life}",
              "{inflict wounds}",
              "{ray of sickness}",
            ],
          },
          2: {
            slots: 3,
            spells: [
              "{blindness/deafness}",
              "{gentle repose}",
              "{hold person}",
              "{ray of enfeeblement}",
              "{spiritual weapon}",
            ],
          },
          3: {
            slots: 3,
            spells: [
              "{animate dead}",
              "{magic circle}",
              "{speak with dead}",
              "{spirit guardians}",
              "{vampiric touch}",
            ],
          },
          4: {
            slots: 3,
            spells: [
              "{banishment}",
              "{blight}",
              "{death ward}",
              "{divination}",
              "{locate creature}",
            ],
          },
          5: {
            slots: 2,
            spells: [
              "{antilife shell}",
              "{cloudkill}",
              "{contagion}",
              "{greater restoration}",
            ],
          },
          6: {
            slots: 1,
            spells: ["{create undead}", "{true seeing}"],
          },
          7: {
            slots: 1,
            spells: ["{divine word}", "{regenerate}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Hold Breath",
        entries: ["Krull can hold his breath for 1 hour."],
      },
      {
        name: "Inescapable Destruction",
        entries: [
          "Necrotic damage dealt by Krull's spells ignores resistance to necrotic damage.",
        ],
      },
    ],
    action: [
      {
        name: "Claws",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d4 + 5}) piercing damage.",
        ],
      },
      {
        name: "+1 Maul",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d6 + 6}) bludgeoning damage plus 9 ({@damage 2d8}) necrotic damage.",
        ],
      },
      {
        name: "Shell Defense",
        entries: [
          "Krull withdraws into his shell. Until he emerges as a bonus action, he has a +4 bonus to AC and has advantage on Strength and Constitution saving throws. While in his shell, Krull is {@condition prone}, his speed is 0 and can't increase, he has disadvantage on Dexterity saving throws, he can't take reactions, and the only action he can take is to emerge from his shell.",
        ],
      },
    ],
    attachedItems: ["+1 maul|dmg"],
    traitTags: ["Hold Breath"],
    languageTags: ["AQ", "C", "DR"],
    damageTags: ["B", "N", "P"],
    damageTagsSpell: ["I", "N", "O", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW"],
    conditionInflictSpell: [
      "blinded",
      "deafened",
      "incapacitated",
      "paralyzed",
      "poisoned",
      "stunned",
    ],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Lulu",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 5,
    _copy: {
      name: "Hollyphant",
      source: "BGDIA",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the hollyphant",
          with: "Lulu",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Mad Maggie",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 74,
    _copy: {
      name: "Night Hag",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the hag",
          with: "Maggie",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Mahadi the Rakshasa",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 127,
    size: ["M"],
    type: "fiend",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 195,
      formula: "23d8 + 92",
    },
    speed: {
      walk: 40,
    },
    str: 14,
    dex: 18,
    con: 18,
    int: 14,
    wis: 18,
    cha: 20,
    save: {
      wis: "+9",
      cha: "+10",
    },
    skill: {
      arcana: "+7",
      deception: "+10",
      insight: "+9",
      perception: "+9",
    },
    senses: ["darkvision 120 ft."],
    passive: 19,
    resist: [
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    vulnerable: [
      {
        vulnerable: ["piercing"],
        note: "from magic weapons wielded by good creatures",
        cond: true,
      },
    ],
    languages: ["all (can read only)", "Common", "Infernal"],
    cr: "14",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Mahadi's innate spellcasting ability is Charisma (spell save {@dc 18}, {@hit 9} to hit with spell attacks). He can innately cast the following spells, requiring no material components:",
        ],
        will: [
          "{detect thoughts}",
          "{disguise self}",
          "{mage hand}",
          "{minor illusion}",
        ],
        daily: {
          "3e": [
            "{charm person}",
            "{detect magic}",
            "{dispel magic}",
            "{hellish rebuke}",
            "{invisibility}",
            "{major image}",
            "{speak with dead}",
            "{suggestion}",
          ],
          "1e": [
            "{banishment}",
            "{demiplane}",
            "{dominate person}",
            "{fly}",
            "{forcecage}",
            "{geas}",
            "{plane shift}",
            "{true seeing}",
          ],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Limited Magic Immunity",
        entries: [
          "Mahadi can't be affected or detected by spells of 6th level or lower unless he wishes to be. He has advantage on saving throws against all other spells and magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["Mahadi's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Mahadi makes four claw attacks."],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}9 ({@damage 2d6 + 2}) slashing damage, and the target is cursed if it's a creature. The curse takes effect whenever the target takes a short or long rest, filling the target's thoughts with horrible images and dreams. The cursed target gains no benefit from finishing a short or long rest. The curse lasts until it is lifted by a {remove curse} spell or similar magic.",
        ],
      },
      {
        name: "Summon Erinyes (1/Day)",
        entries: [
          "Mahadi summons Ilzabet, an erinyes bound to him by an infernal contract. The erinyes appears in an unoccupied space within 60 feet of him, acts as his ally, and can't summon other devils. The erinyes remains for 10 minutes or until Mahadi dismisses it as an action. If the erinyes dies, Mahadi loses this action option.",
        ],
      },
    ],
    traitTags: ["Magic Weapons"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "I", "XX"],
    damageTags: ["S"],
    damageTagsSpell: ["F", "Y"],
    spellcastingTags: ["I"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Master of Souls",
    source: "BGDIA",
    page: 234,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [12],
    hp: {
      average: 45,
      formula: "6d8 + 18",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 17,
    int: 19,
    wis: 14,
    cha: 13,
    save: {
      wis: "+4",
    },
    skill: {
      arcana: "+6",
      religion: "+6",
    },
    passive: 12,
    languages: ["Abyssal", "Common", "Infernal"],
    cr: "4",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The master of souls is a 5th-level spellcaster. Its spellcasting ability is Intelligence (spell save {@dc 14}, {@hit 6} to hit with spell attacks). It has the following wizard spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              '{chill touch} (see "Actions" below)',
              "{mage hand}",
              "{message}",
              "{prestidigitation}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{burning hands}",
              "{detect magic}",
              '{ray of sickness} (see "Actions" below)',
              "{shield}",
            ],
          },
          2: {
            slots: 3,
            spells: [
              "{darkness}",
              "{misty step}",
              '{scorching ray} (see "Actions" below)',
            ],
          },
          3: {
            slots: 2,
            spells: ["{animate dead}", "{fireball}"],
          },
        },
        ability: "int",
      },
    ],
    trait: [
      {
        name: "Grave Magic",
        entries: [
          "When the master of souls cast a spell that deals damage, it can change the spell's damage type to necrotic.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The master of souls attacks twice with its flail."],
      },
      {
        name: "Silvered Skull Flail",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d8}) bludgeoning damage plus 14 ({@damage 4d6}) necrotic damage, and the target has disadvantage on all saving throws until the end of the master of souls' next turn.",
        ],
      },
      {
        name: "Chill Touch (Cantrip)",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 120 ft., one creature. {@h}13 ({@damage 2d8}) necrotic damage, and the target can't regain hit points until the start of the master of souls' next turn. If the target is undead, it has disadvantage on attack rolls against the master of souls for the same duration.",
        ],
      },
      {
        name: "Ray of Sickness (1st-Level Spell; Requires a Spell Slot)",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 60 ft., one creature. {@h}9 ({@damage 2d8}) poison damage, and the target must succeed on a {@dc 14} Constitution saving throw or be {@condition poisoned} until the end of the master of souls' next turn. If the master of souls casts this spell using a spell slot of 2nd level or higher, the damage increases by {@dice 1d8} for each slot level above 1st.",
        ],
      },
      {
        name: "Scorching Ray (2nd-Level Spell; Requires a Spell Slot)",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 120 ft., one target per ray (3 rays if a 2nd-level spell slot is used, 4 rays if a 3rd-level spell slot is used). {@h}7 ({@damage 2d6}) fire damage per ray.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "C", "I"],
    damageTags: ["B", "F", "I", "N"],
    damageTagsSpell: ["F", "I", "N"],
    spellcastingTags: ["CW"],
    miscTags: ["MW"],
    conditionInflict: ["poisoned"],
    conditionInflictSpell: ["poisoned"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Mortlock Vanthampur",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 26,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [12],
    hp: {
      average: 90,
      formula: "12d8 + 36",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 14,
    con: 17,
    int: 10,
    wis: 12,
    cha: 13,
    skill: {
      athletics: "+6",
      intimidation: "+5",
    },
    passive: 11,
    languages: ["Common"],
    cr: "3",
    trait: [
      {
        name: "Indomitable (2/Day)",
        entries: [
          "Mortlock can reroll a saving throw that he fails. He must use the new roll.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Mortlock makes two attacks with his greatclub."],
      },
      {
        name: "Greatclub",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}9 ({@damage 2d4 + 4}) bludgeoning damage, plus 5 ({@damage 2d4}) bludgeoning damage if Mortlock has taken any damage since his last turn.",
        ],
      },
      {
        name: "Heavy Crossbow",
        entries: [
          "{@atk rw} {@hit 4} to hit, range 100/400 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["greatclub|phb", "heavy crossbow|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["B", "P"],
    miscTags: ["MW", "RNG", "RW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Necromite of Myrkul",
    source: "BGDIA",
    page: 234,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [11],
    hp: {
      average: 13,
      formula: "2d8 + 4",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 13,
    con: 15,
    int: 16,
    wis: 11,
    cha: 10,
    skill: {
      arcana: "+5",
      religion: "+5",
    },
    passive: 10,
    languages: ["Abyssal", "Common", "Infernal"],
    cr: "1/2",
    action: [
      {
        name: "Skull Flail",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d8}) bludgeoning damage.",
        ],
      },
      {
        name: "Claws of the Grave",
        entries: [
          "{@atk rs} {@hit 5} to hit, range 90 ft., one target. {@h}8 ({@damage 2d4 + 3}) necrotic damage.",
        ],
      },
    ],
    languageTags: ["AB", "C", "I"],
    damageTags: ["B", "N"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Necrotic Centipede",
    source: "BGDIA",
    page: 119,
    _copy: {
      name: "Remorhaz",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "remorhaz",
          with: "centipede",
        },
        action: {
          mode: "replaceArr",
          replace: "Bite",
          items: {
            name: "Bite",
            entries: [
              "{@atk mw} {@hit 11} to hit, reach 10 ft., one target. {@h}40 ({@damage 6d10 + 7}) piercing damage plus 10 ({@damage 3d6}) necrotic damage. If the target is a creature, it is {@condition grappled} (escape {@dc 17}). Until this grapple ends, the target is {@condition restrained}, and the centipede can't bite another target.",
            ],
          },
        },
      },
    },
    immune: ["necrotic", "fire"],
    trait: [
      {
        name: "Necrotic Body",
        entries: [
          "A creature that touches the centipede or hits it with a melee attack while within 5 feet of it takes 10 ({@damage 3d6}) necrotic damage.",
        ],
      },
    ],
    damageTags: ["A", "N", "P"],
    hasToken: true,
  },
  {
    name: "Night Blade",
    source: "BGDIA",
    page: 233,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "E"],
    ac: [12],
    hp: {
      average: 11,
      formula: "2d8 + 2",
    },
    speed: {
      walk: 40,
    },
    str: 11,
    dex: 15,
    con: 12,
    int: 10,
    wis: 11,
    cha: 14,
    skill: {
      intimidation: "+4",
      stealth: "+6",
    },
    senses: ["darkvision 60"],
    passive: 10,
    languages: ["Common"],
    cr: "1/4",
    trait: [
      {
        name: "Aura of Murder",
        entries: [
          "As long as the night blade is not {@condition incapacitated}, hostile creatures within 5 feet of it gain vulnerability to piercing damage unless they have resistance or immunity to such damage.",
        ],
      },
    ],
    action: [
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    senseTags: ["D"],
    languageTags: ["C"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Nine-Fingers Keene",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 170,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 15,
        from: ["{@item leather armor|phb}"],
      },
    ],
    hp: {
      average: 84,
      formula: "13d8 + 26",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 18,
    con: 14,
    int: 13,
    wis: 17,
    cha: 14,
    save: {
      dex: "+7",
      int: "+4",
    },
    skill: {
      acrobatics: "+10",
      deception: "+5",
      insight: "+6",
      intimidation: "+5",
      perception: "+6",
      "sleight of hand": "+10",
      stealth: "+10",
    },
    passive: 16,
    languages: ["Common", "Thieves' cant"],
    cr: "5",
    trait: [
      {
        name: "Cunning Action",
        entries: [
          "On each of her turns in combat, Nine-Fingers can use a bonus action to take the Dash, Disengage, or Hide action.",
        ],
      },
      {
        name: "Dagger Thrower",
        entries: [
          "Nine-Fingers adds double her proficiency bonus to the damage she deals on ranged attacks made with daggers (already factored into her attacks).",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Nine-Fingers attacks three times with her daggers."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage, plus 6 piercing damage if it's a ranged attack.",
        ],
      },
    ],
    reaction: [
      {
        name: "Uncanny Dodge",
        entries: [
          "Nine-Fingers halves the damage that she takes from an attack that hits her. She must be able to see the attacker.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "TC"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Peacock",
    source: "BGDIA",
    page: 195,
    _copy: {
      name: "Vulture",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "vulture",
          with: "peacock",
        },
      },
    },
    hasToken: true,
  },
  {
    name: "Princeps Kovik",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 91,
    _copy: {
      name: "Chain Devil",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the devil",
          with: "Kovik",
          flags: "i",
        },
      },
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Raggadragga",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 87,
    _copy: {
      name: "Wereboar",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the wereboar",
          with: "Raggadragga",
          flags: "i",
        },
      },
    },
    hp: {
      average: 120,
      formula: "12d8 + 24",
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Reaper of Bhaal",
    source: "BGDIA",
    page: 233,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["C", "E"],
    ac: [15],
    hp: {
      average: 27,
      formula: "5d8 + 5",
    },
    speed: {
      walk: 40,
    },
    str: 11,
    dex: 20,
    con: 13,
    int: 15,
    wis: 12,
    cha: 16,
    skill: {
      intimidation: "+5",
      perception: "+3",
      persuasion: "+5",
      stealth: "+9",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    languages: ["Common"],
    cr: "2",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "The reaper's innate spellcasting ability is Charisma (spell save {@dc 13}). It can innately cast the following spells, requiring no material components:",
        ],
        daily: {
          "1e": ["{charm person}", "{disguise self}", "{sanctuary}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Aura of Murder",
        entries: [
          "As long as the reaper is not {@condition incapacitated}, hostile creatures within 5 feet of it gain vulnerability to piercing damage unless they have resistance or immunity to such damage.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The reaper makes two dagger attacks and uses Shroud Self."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d4 + 5}) piercing damage.",
        ],
      },
      {
        name: "Shroud Self",
        entries: [
          "The reaper magically turns {@condition invisible} until the start of its next turn. This invisibility ends if the reaper makes an attack roll, makes a damage roll, or casts a spell.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["P"],
    spellcastingTags: ["I"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["invisible"],
    conditionInflictSpell: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Rilsa Rael",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 199,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 15,
        from: ["{@item leather armor|phb}"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d8 + 16",
    },
    speed: {
      walk: 30,
    },
    str: 14,
    dex: 18,
    con: 14,
    int: 10,
    wis: 11,
    cha: 15,
    save: {
      dex: "+6",
      wis: "+2",
    },
    skill: {
      acrobatics: "+6",
      athletics: "+4",
      deception: "+4",
      perception: "+2",
      "sleight of hand": "+6",
      stealth: "+6",
    },
    passive: 12,
    languages: ["Common", "Thieves' cant"],
    cr: "3",
    trait: [
      {
        name: "Cunning Action",
        entries: [
          "On each of her turns in combat, Rilsa can use a bonus action to take the Dash, Disengage, or Hide action.",
        ],
      },
      {
        name: "Focus",
        entries: [
          "If Rilsa damages a creature with a weapon attack, she gains advantage on attack rolls against that target until the end of her next turn.",
        ],
      },
      {
        name: "Tactical Leadership",
        entries: [
          "As a bonus action, Rilsa chooses one creature she can see within 30 feet of her. The creature doesn't provoke opportunity attacks until the end of its next turn, provided it can hear Rilsa's commands.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Rilsa makes three weapon attacks."],
      },
      {
        name: "Shortsword",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d6 + 4}) piercing damage.",
        ],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 6} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb", "shortsword|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "TC"],
    damageTags: ["P"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Skeletal Rats",
    source: "BGDIA",
    page: 23,
    _copy: {
      name: "Swarm of Rats",
      source: "MM",
    },
    type: {
      type: "undead",
      swarmSize: "T",
    },
    hasToken: true,
  },
  {
    name: "Skull Lasher of Myrkul",
    source: "BGDIA",
    page: 234,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [12],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 15,
    int: 16,
    wis: 13,
    cha: 10,
    save: {
      wis: "+3",
    },
    skill: {
      arcana: "+5",
      religion: "+5",
    },
    passive: 11,
    languages: ["Abyssal", "Common", "Infernal"],
    cr: "1",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The skull lasher is a 3rd-level spellcaster. Its spellcasting ability is Wisdom (spell save {@dc 13}, {@hit 5} to hit with spell attacks). It has the following wizard spells prepared:",
        ],
        spells: {
          0: {
            spells: ["{mage hand}", "{message}", "{prestidigitation}"],
          },
          1: {
            slots: 4,
            spells: [
              "{detect magic}",
              "{protection from evil and good}",
              '{ray of sickness} (see "Actions" below)',
              "{shield}",
            ],
          },
          2: {
            slots: 2,
            spells: ["{darkness}", "{misty step}"],
          },
        },
        ability: "wis",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The skull lasher makes two attacks with its flail."],
      },
      {
        name: "Iron Skull Flail",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d8}) bludgeoning damage plus 7 ({@damage 2d6}) necrotic damage, and the target has disadvantage on all saving throws until the end of the skull lasher's next turn.",
        ],
      },
      {
        name: "Ray of Sickness (1st-Level Spell; Requires a Spell Slot)",
        entries: [
          "{@atk rs} {@hit 5} to hit, range 60 ft., one creature. {@h}9 ({@damage 2d8}) poison damage, and the target must succeed on a {@dc 13} Constitution saving throw or be {@condition poisoned} until the end of the skull lasher's next turn. If the skull lasher casts this spell using a spell slot of 2nd level or higher, the damage increases by {@dice 1d8} for each slot level above 1st.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "C", "I"],
    damageTags: ["B", "I", "N"],
    damageTagsSpell: ["I"],
    spellcastingTags: ["CW"],
    miscTags: ["MW"],
    conditionInflict: ["poisoned"],
    conditionInflictSpell: ["poisoned"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Smiler the Defiler",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 133,
    size: ["M"],
    type: {
      type: "fey",
      tags: ["elf"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 18,
        from: ["{@item +2 leather armor}"],
      },
    ],
    hp: {
      average: 165,
      formula: "22d8 + 66",
    },
    speed: {
      walk: 30,
    },
    str: 14,
    dex: 20,
    con: 16,
    int: 18,
    wis: 11,
    cha: 18,
    skill: {
      deception: "+7",
      persuasion: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    resist: [
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    languages: ["Common", "Elvish", "Sylvan"],
    cr: "7",
    spellcasting: [
      {
        name: "Innate Spellcasting",
        headerEntries: [
          "Smiler's innate spellcasting ability is Charisma (spell save {@dc 15}). He can innately cast the following spells, requiring no material components:",
        ],
        will: ["{charm person}", "{Tasha's hideous laughter}"],
        daily: {
          "3e": ["{confusion}", "{enthrall}", "{suggestion}"],
          "1e": ["{hallucinatory terrain}", "{Otto's irresistible dance}"],
        },
        ability: "cha",
      },
    ],
    trait: [
      {
        name: "Fey Step {@recharge 4}",
        entries: [
          "As a bonus action, Smiler can teleport up to 30 feet to an unoccupied space that he can see or to the empty seat of his infernal war machine.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "Smiler has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Equipment",
        entries: [
          "Smiler wears +2 leather armor. He carries seven soul coins in a bag and a +1 shortsword",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Smiler makes two weapon attacks. He can cast a spell in place of one of these attacks.",
        ],
      },
      {
        name: "+1 Shortsword",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d6 + 6}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["+1 shortsword|dmg"],
    traitTags: ["Magic Resistance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "E", "S"],
    damageTags: ["P"],
    spellcastingTags: ["I"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Sylvira Savikas",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 46,
    _copy: {
      name: "Archmage",
      source: "MM",
      _trait: {
        name: "Tiefling",
        source: "PHB",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the archmage",
          with: "Sylvira",
          flags: "i",
        },
        _: [
          {
            mode: "addSkills",
            skills: {
              investigation: 2,
            },
          },
        ],
      },
    },
    alignment: ["L", "N"],
    languages: [
      "Abyssal",
      "Celestial",
      "Common",
      "Draconic",
      "Infernal",
      "Primordial",
    ],
    languageTags: ["AB", "C", "CE", "DR", "I", "P"],
    spellcastingTags: ["CW", "I"],
    hasToken: true,
  },
  {
    name: "Thavius Kreeg",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 42,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [10],
    hp: {
      average: 40,
      formula: "9d8",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 10,
    con: 11,
    int: 15,
    wis: 18,
    cha: 16,
    skill: {
      deception: "+5",
      medicine: "+6",
      persuasion: "+5",
      religion: "+4",
    },
    passive: 14,
    languages: ["Abyssal", "Common", "Infernal"],
    cr: "1/2",
    trait: [
      {
        name: "Shadow of Guilt",
        entries: [
          "Thavius's shadow is that of a pudgy, horned devil with small wings.",
        ],
      },
    ],
    action: [
      {
        name: "Mace",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d6 + 1}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["mace|phb"],
    languageTags: ["AB", "C", "I"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Thurstwell Vanthampur",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 34,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [9],
    hp: {
      average: 5,
      formula: "2d8 - 4",
    },
    speed: {
      walk: 30,
    },
    str: 7,
    dex: 8,
    con: 6,
    int: 15,
    wis: 17,
    cha: 12,
    skill: {
      deception: "+3",
      insight: "+5",
      perception: "+5",
      religion: "+4",
    },
    passive: 15,
    languages: ["Common", "Elvish", "Infernal"],
    cr: "1/8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Thurstwell is a 2nd-level spellcaster. His spellcasting ability is Wisdom (spell save {@dc 13}). He has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{guidance}",
              '{sacred flame} (see "Actions" below)',
              "{thaumaturgy}",
            ],
          },
          1: {
            slots: 3,
            spells: ["{command}", "{detect evil and good}", "{sanctuary}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Dark Devotion",
        entries: [
          "Thurstwell has advantage on saving throws against being {@condition charmed} or {@condition frightened}.",
        ],
      },
    ],
    action: [
      {
        name: "Sacred Flame (Cantrip)",
        entries: [
          "Flame-like radiance descends on one creature Thurstwell can see within 60 feet of him. The target must succeed on a {@dc 13} Dexterity saving throw or take 4 ({@damage 1d8}) radiant damage, gaining no benefit from cover.",
        ],
      },
    ],
    languageTags: ["C", "E", "I"],
    damageTags: ["R"],
    damageTagsSpell: ["R"],
    spellcastingTags: ["CC"],
    conditionInflictSpell: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Torogar Steelfist",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 112,
    size: ["L"],
    type: "monstrosity",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 168,
      formula: "16d10 + 80",
    },
    speed: {
      walk: 40,
    },
    str: 25,
    dex: 17,
    con: 20,
    int: 8,
    wis: 9,
    cha: 16,
    save: {
      str: "+11",
      con: "+9",
    },
    senses: ["darkvision 60 ft."],
    passive: 9,
    languages: ["Abyssal", "Common"],
    cr: "11",
    trait: [
      {
        name: "Goring Rush",
        entries: [
          "Immediately after using the Dash action, Torogar can make one melee attack with his horns.",
        ],
      },
      {
        name: "Labyrinthine Recall",
        entries: ["Torogar can perfectly recall any path he has traveled."],
      },
      {
        name: "Rage (Recharges after a Short or Long Rest)",
        entries: [
          "As a bonus action, Torogar can enter a rage that lasts for 1 minute. The rage ends early if Torogar is knocked {@condition unconscious} or if his turn ends and he hasn't attacked a hostile creature or taken damage since his last turn. While raging, Torogar gains the following benefits:",
          "He has advantage on Strength checks and Strength saving throws.",
          "He deals an extra 3 damage when he hits a target with a melee weapon attack.",
          "He has resistance to bludgeoning, piercing, and slashing damage.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Torogar wears {@item gauntlets of flaming fury|bgdia} and a {@item belt of fire giant strength}. Without the belt, his Strength is 21. He also carries a {@item soul coin|bgdia}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Torogar makes three attacks: two with his scimitars and one with his horns.",
        ],
      },
      {
        name: "Scimitar",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 5 ft., one target. {@h}14 ({@damage 2d6 + 7}) slashing damage, or 17 ({@damage 2d6 + 10}) slashing damage while raging, plus 3 ({@damage 1d6}) fire damage from the gauntlets of flaming fury.",
        ],
      },
      {
        name: "Horns",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 5 ft., one target. {@h}16 ({@damage 2d8 + 7}) piercing damage, or 19 ({@damage 2d8 + 10}) piercing damage while raging.",
        ],
      },
    ],
    attachedItems: ["scimitar|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["AB", "C"],
    damageTags: ["F", "P", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Traxigor",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 50,
    _copy: {
      name: "Archmage",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the archmage",
          with: "Traxigor",
          flags: "i",
        },
        _: {
          mode: "replaceSpells",
          spells: {
            7: [
              {
                replace: "{teleport}",
                with: "{plane shift}",
              },
            ],
          },
        },
      },
    },
    size: ["T"],
    type: "beast",
    alignment: ["C", "G"],
    str: 3,
    languages: [
      "Common",
      "Draconic",
      "Dwarvish",
      "Gnomish",
      "Halfling",
      "Troglodyte",
    ],
    languageTags: ["C", "D", "DR", "G", "H", "OTH"],
    hasToken: true,
  },
  {
    name: "Tressym",
    source: "BGDIA",
    page: 241,
    _copy: {
      name: "Tressym",
      source: "SKT",
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Ulder Ravengard",
    isNpc: true,
    isNamedCreature: true,
    source: "BGDIA",
    page: 70,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 20,
        from: ["{@item plate armor|phb}", "{@item shield|phb}"],
      },
    ],
    hp: {
      average: 112,
      formula: "15d8 + 45",
    },
    speed: {
      walk: 25,
    },
    str: 17,
    dex: 14,
    con: 16,
    int: 11,
    wis: 10,
    cha: 17,
    save: {
      con: "+6",
      wis: "+3",
    },
    skill: {
      athletics: "+6",
      intimidation: "+6",
      perception: "+3",
    },
    passive: 13,
    languages: ["Common"],
    cr: "5",
    action: [
      {
        name: "Multiattack",
        entries: [
          "Ulder makes three melee attacks, only one of which can be with his shield.",
        ],
      },
      {
        name: "+1 Longsword",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) slashing damage, or 9 ({@damage 1d10 + 4}) slashing damage when used with two hands.",
        ],
      },
      {
        name: "Shield",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one creature. {@h}6 ({@damage 1d6 + 3}) bludgeoning damage, and Ulder pushes the target 5 feet away from him. Ulder then enters the space vacated by the target. If the target is pushed to within 5 feet of a creature friendly to Ulder, the target provokes an opportunity attack from that creature.",
        ],
      },
    ],
    reaction: [
      {
        name: "Guardian Strike",
        entries: [
          "If an enemy within 5 feet of Ulder attacks a target other than him, Ulder can make a melee attack against that enemy.",
        ],
      },
    ],
    attachedItems: ["+1 longsword|dmg"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["B", "S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Undead Tree",
    source: "BGDIA",
    page: 109,
    _copy: {
      name: "Treant",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "treant",
          with: "tree",
        },
      },
    },
    type: "undead",
    resist: ["necrotic"],
    hasToken: true,
  },
];
